import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "d48a540d-7143-4d84-99b6-4498e86dbb69",
  publicId: "10",
  name: "Sharpness",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01, task02, task03],
};

export default lesson;
